<cm-overlay
  [width]="1150"
  [height]="640"
  header="{{ 'DIAGNOSTICS_BITRATE_TEST' | translate }}"
  >
  <div id="bitrate-container">
    @if (bitrateDiagnostics$ | async; as bitrateDiagnostics) {
      @if (bitrateDiagnostics.report) {
        <div>
          Average Bitrate: {{ bitrateDiagnostics.report.averageBitrate | number: '1.2'}} kbps
        </div>
      } @else {
        {{ bitrateDiagnostics.bitrate | number: '1.2' }} kbps
      }
      @if (bitrateDiagnostics.warning) {
        <div class="warning">{{ bitrateDiagnostics.warning}}</div>
      }
      @if (bitrateDiagnostics.error) {
        <div class="error">{{ bitrateDiagnostics.error | json}}</div>
      }
    }
    <cm-menu-grid
      [items]="items"
      (itemSelected)="onItemSelected($event)"
      style="margin: 50px"
      [columns]="4"
    ></cm-menu-grid>
  </div>
</cm-overlay>

